import { render } from "./AppointmentInfo.vue?vue&type=template&id=e9b838ac&scoped=true&lang=pug"
import script from "./AppointmentInfo.vue?vue&type=script&lang=js"
export * from "./AppointmentInfo.vue?vue&type=script&lang=js"

import "./AppointmentInfo.vue?vue&type=style&index=0&id=e9b838ac&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9b838ac"]])

export default __exports__